<template>
<div class="container-settings">
    <Instructions v-if="instructions" 
    @closeModal="instructions = !instructions" />
    <div id="home" class="animated-topbutton tamanhoicon" @click="submit()">
        <img :src="require('@/assets/buttons/newbuttons/black/home.svg')" />
    </div>
    <h1 class="title title-black">{{$t('menu.settings.title')}}</h1>
    <div class="container-options-settings">
        <span>
            <label class="switch">
                <input type="checkbox" id="soundCheckbox" @click="soundState()" />
                <span class="slider round"></span>
            </label>
            <span class="label-settings"> {{$t('menu.settings.sound')}} </span>
        </span>
        <span>
    <!--<label class="switch">
                <input type="checkbox" id="musicCheckbox" checked />
                <span class="slider round"></span>
            </label>
            <span class="label-settings"> {{$t('menu.settings.music')}} </span>-->
        </span>
        <SwitchLanguage :somActive="somOn" />
    </div>
    <div class="button-list-settings">
        <button class="button-settings tamanho0" @click="teachers">
            {{$t('menu.settings.teachers')}}</button>
        <button class="button-settings tamanho0" @click="parentalGuide">
            {{$t('menu.settings.parental')}}
        </button>
        <button class="button-settings tamanho0" @click="help">
            {{$t('menu.settings.help')}}</button>
        <button class="button-settings tamanho0" @click="credits">
            {{$t('menu.settings.credits')}}</button>

    </div>

    <div class="help tamanhoicon animated-bottombutton" v-if="current_screen != 'Score' && current_screen != 'Congrats' && current_screen != 'SummaryScreen'" @click="instructions = !instructions">
            <img :src="require('@/assets/buttons/newbuttons/general/help.svg')" />
    </div>

    <div @click="onLog" id="backpage" class="animated-bottombutton tamanhoicon">
        <img v-if="!guest" :src="require('@/assets/buttons/newbuttons/black/logout.svg')" />
        <img v-else :src="require('@/assets/buttons/newbuttons/black/login.svg')" />
    </div>
</div>
</template>

<script>
import SwitchLanguage from "@/components/General/SwitchLanguage.vue";
import Instructions from "@/components/Menu/Instructions.vue";


export default {
    name: "Settings",
    emits: ["backMenu", "logout", "login", "instructions"],

    components: {
        SwitchLanguage,
        Instructions
    },
    data() {
        return {
            current_language: 0,
            back: '',
            click: '',
            somOn: true,
            estadoSom: '',
            instructions: false
        };
    },
    props: {
        som: Boolean,
        guest: Boolean
    },
    methods: {
        onLog() {
            if (this.guest) {
                this.$emit('login');
            } else {
                this.$emit('logout');
            }
        },
        somback() {
            if (this.somOn) {
                this.back.play();
            }
        },
        somclick() {
            if (this.somOn) {
                this.click.play();
            }
        },
        soundState() {
            console.log("antes: " + this.somOn);
            this.somOn = !this.somOn;
            console.log("depois: " + this.somOn);
            this.selectedSom = this.somOn;
            this.somclick();
        },
        submit() {
            this.estadoSom = this.somOn
            this.$emit('backMenu', this.estadoSom);
            this.somback();
            console.log("submit: " + this.estadoSom);
        },
        teachers(){
            window.location.href="http://copoem.usal.es/search/";
        },
        credits(){
            window.location.href="http://copoem.esalab.es/";
        },
    },
    created() {
        if (this.som) {
            this.somOn = true;
        } else {
            this.somOn = false;
        }
        if (this.som != '') {
            this.somOn = this.som;
            this.selectedSom = this.somOn;

        }
        console.log("create: " + this.somOn);
    },
    mounted() {
        this.click = new Audio(require('@/assets/sons/click.wav'));
        this.back = new Audio(require('@/assets/sons/back.flac'));

        if (this.somOn) {
            document.getElementById("soundCheckbox").checked = true;
        } else {
            document.getElementById("soundCheckbox").checked = false;
        }
       // document.getElementById("musicCheckbox").checked = false;
    },
};
</script>

<style>
.title-black {
    color: black;
}

.container-settings {
    pointer-events: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-family: Omnes;
    font-style: normal;
}

.container-settings>img {
    width: 100%;
    height: 100%;
    z-index: -1;
    object-fit: cover;
}

.container-settings>* {
    pointer-events: auto;
    flex-shrink: 0;
}

.container-options-settings {
    width: 40%;
    position: absolute;
    top: 35%;
    left: 17%;
    display: flex;
    justify-content: space-around;
    font-size: 1.2em;
    font-weight: bold;
    animation: movecontainersettings 0.5s ease-in-out;
    flex-direction: column;
}

@keyframes movecontainersettings {
    0% {
        left: -10%;
    }

    100% {
        left: 17%;
    }
}

.container-options-settings>span {
    padding-bottom: 4%;
}

.label-settings {
    margin-left: 4%;
}

.button-list-settings {
    position: absolute;
    top: 29%;
    width: 40%;
    right: 3%;
    display: flex;
    justify-content: space-evenly;
    animation: movecontainerbuttonssettings 0.5s ease-in-out;
    flex-direction: column;
}

@keyframes movecontainerbuttonssettings {
    0% {
        right: -10%;
    }

    100% {
        right: 3%;
    }
}

.button-settings {
    background-color: rgba(255, 255, 255);
    border: black solid;
    border-radius: 80px;
    padding: 0.5rem;
    margin-bottom: 4%;
    font-family: Omnes;
    font-weight: bold;
    width: 57%;
}

#logout {
    position: absolute;
    left: 4%;
    bottom: 7%;
    z-index: 10;
}

#home {
    z-index: 10;
    position: absolute;
    left: 4%;
    top: 7%;
}

.language {
    border: none;
    background-color: rgb(255, 255, 255);
    border-radius: 30px;
    width: 120px;
    height: 38px;
    font-family: Omnes;
    border: black 3px solid;
}

/*----------------------------------------------------------switch*/
.switch {
    position: relative;
    display: inline-block;
    width: 68px;
    height: 38px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(255, 255, 255);
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: #B3B3B3;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked+.slider::before {
    background-color: black;
}

input:focus+.slider {
    box-shadow: 0 0 1px black;
}

input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
    border: black 3px solid;

}

.slider.round:before {
    border-radius: 50%;
}

@media only screen and (max-width: 480px) {
    .container-options-settings {
        font-size: 0.8rem;
    }

    .tamanho0 {
        font-size: 0.4rem;
    }

    .switch {
        width: 45px;
        height: 28px;
    }

    .slider:before {
        height: 15px;
        width: 15px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(15px);
        -ms-transform: translateX(15px);
        transform: translateX(15px);
    }

    .language {
        width: 66px;
        height: 28px;
    }

    .language>span>img {
        height: 15px;
        width: 15px;
    }

    .language>span {
        font-size: 0.4rem;
    }
}

@media only screen and (min-width: 480px) and (max-width: 550px) {
    .container-options-settings {
        font-size: 0.9rem;
    }

    .tamanho0 {
        font-size: 0.5rem;
    }

    .switch {
        width: 49px;
        height: 30px;
    }

    .slider:before {
        height: 17px;
        width: 17px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(17px);
        -ms-transform: translateX(17px);
        transform: translateX(17px);
    }

    .language {
        width: 78px;
        height: 30px;
    }

    .language>span>img {
        height: 17px;
        width: 17px;
    }

    .language>span {
        font-size: 0.5rem;
    }
}

@media only screen and (min-width: 550px) and (max-width: 630px) {
    .container-options-settings {
        font-size: 1rem;
    }

    .tamanho0 {
        font-size: 0.6rem;
    }

    .switch {
        width: 53px;
        height: 32px;
    }

    .slider:before {
        height: 19px;
        width: 19px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(19px);
        -ms-transform: translateX(19px);
        transform: translateX(19px);
    }

    .language {
        width: 88px;
        height: 32px;
    }

    .language>span>img {
        height: 19px;
        width: 19px;
    }

    .language>span {
        font-size: 0.6rem;
    }
}

@media only screen and (min-width: 630px) and (max-width: 718px) {
    .container-options-settings {
        font-size: 1.1rem;
    }

    .tamanho0 {
        font-size: 0.7rem;
    }

    .switch {
        width: 57px;
        height: 34px;
    }

    .slider:before {
        height: 21px;
        width: 21px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(21px);
        -ms-transform: translateX(21px);
        transform: translateX(21px);
    }

    .language {
        width: 104px;
        height: 34px;
    }

    .language>span>img {
        height: 21px;
        width: 21px;
    }

    .language>span {
        font-size: 0.7rem;
    }
}

@media only screen and (min-width: 718px) and (max-width: 806px) {
    .container-options-settings {
        font-size: 1.2rem;
    }

    .tamanho0 {
        font-size: 0.8rem;
    }

    .switch {
        width: 61px;
        height: 36px;
    }

    .slider:before {
        height: 23px;
        width: 23px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(23px);
        -ms-transform: translateX(23px);
        transform: translateX(23px);
    }

    .language {
        width: 118px;
        height: 36px;
    }

    .language>span>img {
        height: 23px;
        width: 23px;
    }

    .language>span {
        font-size: 0.8rem;
    }
}

@media only screen and (min-width: 806px) and (max-width: 1024px) {
    .container-options-settings {
        font-size: 1.3rem;
    }

    .tamanho0 {
        font-size: 0.9rem;
    }

    .switch {
        width: 65px;
        height: 38px;
    }

    .slider:before {
        height: 25px;
        width: 25px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(25px);
        -ms-transform: translateX(25px);
        transform: translateX(25px);
    }

    .language {
        width: 120px;
        height: 38px;
    }

    .language>span>img {
        height: 25px;
        width: 25px;
    }

    .language>span {
        font-size: 0.9rem;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {
    .container-options-settings {
        font-size: 1.4rem;
    }

    .tamanho0 {
        font-size: 1rem;
    }

    .switch {
        width: 68px;
        height: 40px;
    }

    .slider:before {
        height: 27px;
        width: 27px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(27px);
        -ms-transform: translateX(27px);
        transform: translateX(27px);
    }

    .language {
        width: 129px;
        height: 40px;
    }

    .language>span>img {
        height: 27px;
        width: 27px;
    }

    .language>span {
        font-size: 1rem;
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1366px) {
    .container-options-settings {
        font-size: 1.6rem;
    }

    .tamanho0 {
        font-size: 1.2rem;
    }

    .switch {
        width: 71px;
        height: 42px;
    }

    .slider:before {
        height: 29px;
        width: 29px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(29px);
        -ms-transform: translateX(29px);
        transform: translateX(29px);
    }

    .language {
        width: 139px;
        height: 42px;
    }

    .language>span>img {
        height: 29px;
        width: 29px;
    }

    .language>span {
        font-size: 1.1rem;
    }
}

@media only screen and (min-width: 1366px) and (max-width: 1540px) {
    .container-options-settings {
        font-size: 1.8rem;
    }

    .tamanho0 {
        font-size: 1.4rem;
    }

    .switch {
        width: 74px;
        height: 44px;
    }

    .slider:before {
        height: 31px;
        width: 31px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(31px);
        -ms-transform: translateX(31px);
        transform: translateX(31px);
    }

    .language {
        width: 155px;
        height: 44px;
    }

    .language>span>img {
        height: 31px;
        width: 31px;
    }

    .language>span {
        font-size: 1.3rem;
    }
}

@media only screen and (min-width: 1540px) and (max-width: 1680px) {
    .container-options-settings {
        font-size: 2rem;
    }

    .tamanho0 {
        font-size: 1.6rem;
    }

    .switch {
        width: 78px;
        height: 46px;
    }

    .slider:before {
        height: 33px;
        width: 33px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(33px);
        -ms-transform: translateX(33px);
        transform: translateX(33px);
    }

    .language {
        width: 172px;
        height: 46px;
    }

    .language>span>img {
        height: 33px;
        width: 33px;
    }

    .language>span {
        font-size: 1.4rem;
    }
}

@media only screen and (min-width: 1680px) and (max-width: 2350px) {
    .container-options-settings {
        font-size: 2.2rem;
    }

    .tamanho0 {
        font-size: 1.8rem;
    }

    .switch {
        width: 82px;
        height: 48px;
    }

    .slider:before {
        height: 35px;
        width: 35px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(35px);
        -ms-transform: translateX(35px);
        transform: translateX(35px);
    }

    .language {
        width: 182px;
        height: 48px;
    }

    .language>span>img {
        height: 35px;
        width: 35px;
    }

    .language>span {
        font-size: 1.5rem;
    }
}

@media only screen and (min-width: 2350px) and (max-width: 2550px) {
    .container-options-settings {
        font-size: 2.4rem;
    }

    .tamanho0 {
        font-size: 2rem;
    }

    .switch {
        width: 86px;
        height: 50px;
    }

    .slider:before {
        height: 37px;
        width: 37px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(37px);
        -ms-transform: translateX(37px);
        transform: translateX(37px);
    }

    .language {
        width: 206px;
        height: 50px;
    }

    .language>span>img {
        height: 40px;
        width: 40px;
    }

    .language>span {
        font-size: 1.8rem;
    }
}

@media only screen and (min-width: 2550px) {
    .container-options-settings {
        font-size: 4rem;
    }

    .tamanho0 {
        font-size: 3.6rem;
    }

    .switch {
        width: 183px;
        height: 100px;
    }

    .slider.round {
        border-radius: 50px;
    }

    .slider:before {
        height: 83px;
        width: 83px;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(83px);
        -ms-transform: translateX(83px);
        transform: translateX(83px);
    }

    .language {
        width: 348px;
        height: 100px;
        border-radius: 50px;
    }

    .language>span>img {
        height: 83px;
        width: 83px;
    }

    .language>span {
        font-size: 3rem;
    }
}
</style>
